// components/common/FormField.jsx

const FormField = ({
  label,
  error,
  children,
  required = false,
}) => {
  return (
    <div>
      <label className="block font-medium mb-1">
        {label}
        {required && (
          <span className="text-red-500 ml-1">*</span>
        )}
      </label>

      {children}

      {error && (
        <p className="text-red-500 text-sm mt-1">
          {error}
        </p>
      )}
    </div>
  );
};

export default FormField;